import {SuccessButtonColorEnum} from '@/services/api/nswag/stapiclient_generated';
import {UserStore} from '@/store/user-module';

export function setPrimaryColor(primaryColor: string) {
  document.documentElement.style.setProperty('--bg-primary-normal', primaryColor);
  document.documentElement.style.setProperty('--text-primary-normal', pickTextColorClassBased(primaryColor));

  let primaryLight = lightenDarkenColor(primaryColor, 10);
  let primaryDark = lightenDarkenColor(primaryColor, -10);
  let primaryLighter = lightenDarkenColor(primaryColor, 20);
  let primaryDarker = lightenDarkenColor(primaryColor, -20);

  document.documentElement.style.setProperty('--bg-primary-lighter', primaryLighter);
  document.documentElement.style.setProperty('--text-primary-lighter', pickTextColorClassBased(primaryLighter));
  document.documentElement.style.setProperty('--bg-primary-light', primaryLight);
  document.documentElement.style.setProperty('--text-primary-light', pickTextColorClassBased(primaryLight));

  document.documentElement.style.setProperty('--bg-primary-dark', primaryDark);
  document.documentElement.style.setProperty('--text-primary-dark', pickTextColorClassBased(primaryDark));
  document.documentElement.style.setProperty('--bg-primary-darker', primaryDarker);
  document.documentElement.style.setProperty('--text-primary-darker', pickTextColorClassBased(primaryDarker));
}

export function setSecondaryColor(secondaryColor: string) {
  document.documentElement.style.setProperty('--bg-secondary-normal', secondaryColor);
  document.documentElement.style.setProperty('--text-secondary-normal', pickTextColorClassBased(secondaryColor));

  let secondaryLighter = lightenDarkenColor(secondaryColor, 20);
  let secondaryLight = lightenDarkenColor(secondaryColor, 10);
  let secondarySlightlyDarker = lightenDarkenColor(secondaryColor, -8); // Ich versteck das hier mal ganz heimlich :D
  let secondaryDark = lightenDarkenColor(secondaryColor, -10);
  let secondaryDarker = lightenDarkenColor(secondaryColor, -20);

  document.documentElement.style.setProperty('--bg-secondary-lighter', secondaryLighter);
  document.documentElement.style.setProperty('--text-secondary-lighter', pickTextColorClassBased(secondaryLighter));
  document.documentElement.style.setProperty('--bg-secondary-light', secondaryLight);
  document.documentElement.style.setProperty('--text-secondary-light', pickTextColorClassBased(secondaryLight));

  document.documentElement.style.setProperty('--bg-secondary-dark', secondaryDark);
  document.documentElement.style.setProperty('--text-secondary-dark', pickTextColorClassBased(secondaryDark));
  document.documentElement.style.setProperty('--bg-secondary-darker', secondaryDarker);
  document.documentElement.style.setProperty('--text-secondary-darker', pickTextColorClassBased(secondaryDarker));

  if (secondaryColor.toLowerCase() == '#6ec06e') {
    document.documentElement.style.setProperty('--bg-secondary-slightlydarker', secondarySlightlyDarker);
  } else {
    document.documentElement.style.setProperty('--bg-secondary-slightlydarker', secondaryColor);
  }
}

function pickTextColorClassBased(hexcolor: string) {
  // If a leading # is provided, remove it
  if (hexcolor.slice(0, 1) === '#') {
    hexcolor = hexcolor.slice(1);
  }

  // If a three-character hexcode, make six-character
  if (hexcolor.length === 3) {
    hexcolor = hexcolor
      .split('')
      .map(function (hex) {
        return hex + hex;
      })
      .join('');
  }

  // Convert to RGB value
  let r = parseInt(hexcolor.substr(0, 2), 16);
  let g = parseInt(hexcolor.substr(2, 2), 16);
  let b = parseInt(hexcolor.substr(4, 2), 16);

  // Get YIQ ratio
  let yiq = (r * 299 + g * 587 + b * 114) / 1000;

  // Check contrast
  return yiq >= 160 ? '#424242' : '#f4f4f4';
}

export function isDarkColor(hexcolor: string){
  return pickTextColorClassBased(hexcolor) == '#f4f4f4';
}

export function successButtonColorClass(successButtonColorEnum: SuccessButtonColorEnum){
  switch(successButtonColorEnum){
    case SuccessButtonColorEnum.Green:
      return '';
    case SuccessButtonColorEnum.Primary:
      return 'success-primary';
    case SuccessButtonColorEnum.Secondary:
      return 'success-secondary';
  }
}

function lightenDarkenColor(color: string, percent: number) {
  var R = parseInt(color.substring(1,3),16);
  var G = parseInt(color.substring(3,5),16);
  var B = parseInt(color.substring(5,7),16);

  R = parseInt((R * (100 + percent) / 100).toString());
  G = parseInt((G * (100 + percent) / 100).toString());
  B = parseInt((B * (100 + percent) / 100).toString());

  R = (R<255)?R:255;
  G = (G<255)?G:255;
  B = (B<255)?B:255;

  var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
  var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
  var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));

  return "#"+RR+GG+BB;
}
